<template>
  <div
    class="w-full rounded-t bg-white mb-0 px-6 py-6 flex justify-between uppercase font-bold items-center"
  >
    <button @click="handleGoBack" class="flex">
      <IconChevronLeft />{{ formattedComponentName(title) }}
    </button>
    <transition
      enter-active-class="duration-300 ease-out"
      enter-from-class="transform opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="transform opacity-0"
      mode="out-in"
    >
      <div class="text-center flex justify-end items-center mr-2">
        <button
          @click="handleCreate"
          v-if="getOperationMode === 'create'"
          class="inline-flex items-center bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
          type="button"
        >
          Save
          <IconSync class="ml-1 animate-spin" v-if="getSliderCreateLoading" />
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import IconSync from "@/assets/icons/IconSync";
import IconChevronLeft from "@/assets/icons/IconChevronLeft";

export default {
  name: "ImageSliderCreatePageHeader",
  components: {
    IconSync,
    IconChevronLeft
  },
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      required: true
    },
    handleCreate: {
      type: Function,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getOperationMode", "getSliderCreateLoading"])
  },
  methods: {
    formattedComponentName(name) {
      const splitName = name.split("_");
      splitName[0] = splitName[0].toUpperCase();
      return splitName.join(" ");
    },
    handleGoBack() {
      this.$router.back();
    }
  }
};
</script>
